import * as deepObject from 'deep-object-diff'
import TableHelper from '../../TableHelper'
import { PermissionResult } from '../../../helpers/permission-checker.helper'
import { hasUrlFilters } from '../../../helpers/filter.helper'

type ActionRefsType = {
  edit: Array<any>,
  delete: Array<any>
}

export type ListComponentProps = {
  permissions?: PermissionResult,

  loading: boolean,
  history: any
}

export default class ListComponent<T> extends TableHelper<T> {

  actionRefs: ActionRefsType = {
    edit: [],
    delete: []
  }

  protected load() {}

  componentDidMount() {
    if (!hasUrlFilters()) {
      this.load()
    }
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    const { searchOptions }: any = this.props

    // Validate permissions
    this.validateAccessPermissions()

    if (searchOptions?.search) {
      // Check if our search has changed and sync with our table helper
      const isDiff = Object.keys(deepObject.diff(this.searchOptions.search, searchOptions.search)).length > 0
      if (isDiff) {
        this.searchOptions.search = searchOptions.search
      }
    }
  }

  validateAccessPermissions = () => {
    const { permissions: listPermissions }: any = this.props

    if (listPermissions) {
      const permissions = listPermissions as PermissionResult

      if (!permissions.save) {
        this.actionRefs.edit.forEach(ref => {
          if (ref) {
            ref.style.display = !permissions.save ? 'none' : ''
          }
        })
      }
      if (!permissions.delete) {
        this.actionRefs.delete.forEach(ref => {
          if (ref) {
            ref.style.display = !permissions.delete ? 'none' : ''
          }
        })
      }
    }
  }
}
